// extracted by mini-css-extract-plugin
export default {"portal":"IconTooltip-module__portal__a5N8S","icon":"IconTooltip-module__icon__pihlm","message":"IconTooltip-module__message__FZeGp","content":"IconTooltip-module__content__J5aMI"};